var korean = {
  app_uploadApp: '애플리케이션 업로드',
  app_No: '번호',
  app_terNo: '단말기번호',
  app_name: '이름',
  app_appName: '애플리케이션 이름',
  app_appType: '애플리케이션 유형',
  app_insType: '설치 유형',
  app_vStatus: '심사상태',
  app_ulTime: '업로드시간',
  app_appLoding: '애플리케이션 업로드중',
  app_newgVer: '최신 버전 넘버',
  app_operate: '동작',
  app_type: '유형',
  app_del: '삭제',
  app_pause: '스탑',
  app_continue: '계속',
  app_status: '상태',
  app_new: '새로 추가',
  app_yes: '네',
  app_no: '아니오',
  app_selectAll: '전부 선택0',
  app_save: '저장',
  app_process: '진도',
  app_push: '푸시',
  app_offShelf: '내리다',
  app_mulOffShelf: '전부 내리다',
  app_isOffShelf: '애플리케이션을 내리겠습니까?',
  app_isDelApp: '애플리케이션을 삭제하시겠습니까?',
  app_chooseOneMust: '적어도 하나의 애플리케이션을 선택해야 합니다',
  app_cantDelTask: '삭제 불가능한 task를 선택했습니다',
  app_oneRecordMust: '적어도 하나의 기록을 선택해야 합니다',
  app_phoneIllegal: '번화번호가 불법입니다',
  app_groupName: '분류명',
  app_sure: '확인',
  app_query: '조희',
  app_reset: '다시 설정',
  app_cancel: '취소',
  app_edit: '편집',
  app_add: '추가',
  app_verify: '심사',
  app_isPass: '통과 여부',
  app_pass: '통과',
  app_ban: '불통',
  app_noInput: '미기재',
  app_banReason: '거절원인',
  app_filter: '필터',
  app_prePushVerify: '심사송부대기',
  app_preVerify: '심사',
  app_verifyPass: '통과',
  app_verifyNotPass: '불통',
  app_success: '성공',
  app_submit: '제출',
  app_tip: '제시',
  app_online: '온라인',
  app_offline: '오프라인',
  app_fileOver: '파일 용량 초과',
  app_onlyApk: 'apk파일만 업로드 가능',
  app_onlyApk_2: 'apk/hap파일만 업로드 가능',
  app_tipViewTask: '푸시 성공했습니다.태스크매니지먼트에서 푸시 진도를 확인하세요',
  app_tipMkDel: '애플리케이션 삭제하면 애플리케이션 스토어중 애플리케이션도 같이 삭제됩니다.삭제하시겠습니까?',
  app_tipAppEdit: '삭제 후 복원 불가능합니다.삭제하시겠습니까?',
  app_tipVerify: '심사를 제출하시겠습니까?',
  app_rqsError: '요청오류',
  app_not_auth: 'TMS 비활성화',
  app_mulAdd: '선택추가',
  app_select: '선택하세요',
  app_input: '내용을 입력하세요',
  app_inputCp: '완전하게 입력하세요',
  app_inputName: '이름을 입력하세요',
  app_inputContact: '연락인을 입력하세요',
  app_inputTruePhone: '정확한 번호를 입력하세요',
  app_inputAddr: '주소를 입력하세요',
  app_inputVer: '버전을 입력하세요',
  app_inputVerTag: '버전마커를 입력하세요',
  app_inputID: '신원을 입력하십시오',
  app_inputPkg: '패키지명을 입력하세요',
  app_noVerTag: '버전마커가 없습니다',
  app_inputIntrol: '설명을 입력하세요',
  app_selectType: '애플리케이션 유형을 선택해주세요',
  app_ulApp: '애플리케이션을 업로드하세요',
  app_ulIcon: '작은 아이콘을 업로드하세요',
  app_ulLarIcon: '큰 아이콘을 업로드하세요',
  app_ulScreenShot: '캡쳐이미지를 업로드하세요',
  app_smVerify: '심사 제출',
  app_baseInfo: '기본정보',
  app_version: '버전번호',
  app_checkupsp: '검사 업데이트 주기',
  app_autoUpload: '자동입력',
  app_verTag: '버전 마크',
  app_ID: '신분증',
  app_fminfo: '펌웨어 정보',
  app_terstatus: '터미널 상태',
  app_sysinfo: '시스템 정보',
  app_package: '애플리케이션 패키지명',
  app_introl: '애플리케이션 소개',
  app_geo: '지리적 위치',
  app_ustart: '시작하지 않음',
  app_outofdate: '이미 기한이 지나서',
  app_udState: '업데이트 설명',
  app_rcmsg: '수신 메시지',
  app_icon: '애플리케이션 작은 아이콘',
  app_larIcon: '애플리케이션 큰 아이콘',
  app_screenShot: '애플리케이션 캡쳐',
  app_appVer: '애플리케이션 버전',
  app_createTime: '생성시간',
  app_hbsp: '심장 박동 주기',
  app_close: '끄기',
  app_ulNew: '새 버전 업로드',
  app_selectApp: '애플리케이션 선택',
  app_testInstall: '설치 테스트',
  app_ulAppState: '파일을 여기로 끌어와서 업로드 버튼을 누른다.apk파일 업로드만 가능하다',
  app_clickUpdate: '업로드 클릭',
  app_udType: '업로드 방식',
  app_allUpdate: '토탈 업데이트',
  app_iconState: '144x144,100k이하 사이즈',
  app_larIconState: '512x512,200k이하 사이즈',
  app_autoInstall: '자동설치',
  app_addApp: '애플리케이션 추가',
  app_classIntrol: '분류 추천',
  app_homeIntrol: '메인 페이지 추천',
  app_isIntroClass: '분류에 추천 여부',
  app_isIntroHome: '메인 페이지에 추천 여부',
  app_isUnbindApp: '애플리케이션 제거하시겠습니까?',
  app_isOffApp: '애플리케이션을 내리시겠습니까?',
  app_isDelData: '데이터를 삭제하시겠습니까?',
  app_inputAName: '이름을 입력해주세요',
  app_oneDeviceMust: '적어도 하나의 무준을 파악해야 합니다',
  app_fileSize: '파일 사이즈',
  app_addPush: '푸시 추가',
  app_viewPushHis: '푸시기록조회',
  app_pushTimes: '횟수조회',
  app_hisVer: '히스토리 버전',
  app_pushHistory: '히스토리 푸시',
  app_pushInstall: '설정 푸시',
  app_animatePush: '애니메이션 푸시',
  app_animateMake: '애니메이션 맞춤제작',
  app_pushDevice: '장치를 푸시하였습니다',
  app_deviceNum: '장치수량',
  app_deviceName: '장치명',
  app_deviceNo: '장치번호',
  app_pushTime: '푸시시간',
  app_distributor: '유통업자',
  app_dParent: '상급 유통업자',
  app_unbind: '제거',
  app_mulUnbind: '선택제거',
  app_mulPush: '선택푸시',
  app_searchTerminal: '단말번호를 입력하고 검색하세요',
  app_terName: '단말 이름',
  app_taskName: '태스크명',
  app_taskDetail: '태스크내용',
  app_deviceTotal: '장치 총수량',
  app_downloading: '다운로드중',
  app_downFail: '다운로드 실패',
  app_update: '업데이트',
  app_md5Fail: 'MD5인증 실패',
  app_theNewgVer: '현재 버전은 최신버전입니다',
  app_fileFmIllegal: '파일포멧이 오류입니다',
  app_updateFail: '업데이트 실패',
  app_usrCancelUpdate: '유저 취소 업데이트',
  app_pushFail: '푸시 실패',
  app_downFinish: '다운로드 완료',
  app_updateSuccess: '업데이트 완료',
  app_fail: '실패',
  app_addres: '주소',
  app_mulDel: '대량 삭제',
  app_contact: '연락인',
  app_contactPhone: '연락처',
  app_typeName: '유형 이름',
  app_customs: '맞춤제작',
  app_clear: '클리어',
  app_customsTime: '맞춤제작시간',
  app_launchAnimate: '부팅 애니메이션',
  app_pushsctipinstall: '보내다 성공 터미널 팁 응용 다운로드',
  app_onLogo: '부팅시 LOGO',
  app_animateName: '애니메이션 이름',
  app_playPlace: '플레이 위치',
  app_aSrcFile: '애니메이션 소스파일',
  app_asfState: '애니메이션 분할화면 파일명은 part0.zip이여야 한다',
  app_downExp: '다운로드 예시',
  app_ologoState: '애니메이션 플레이 정지 후 화면',
  app_picSize: '이미지 사이즈',
  app_picSizeState: '너비*높이를 입력하다',
  app_frame: '프레임',
  app_frameState: '초당 플레이하는 애니메이션 수량',
  app_aCycleTime: '애니메이션 반복 횟수',
  app_cyclePlay: '반복 플레이',
  app_playOnce: '한번 플레이',
  app_fileNameOnly: '파일명은',
  app_inputNumber: '숫자 입력해주세요',
  app_picUlError: '이미지 업로드 오류',
  app_inputAnimateName: '애니메이션 이름 입력해주세요',
  app_selectAnimateType: '애니메이션 유형을 선택해주세요',
  app_selectPlayPlace: '플레이 위치 선택해주세요',
  app_uploadAnimateFile: '애니메이션 파일 업로드해주세요',
  app_uploadOnPic: '부팅 이미지 업로드해주세요',
  app_sureDelTip: '삭제하시겠습니까?삭제 후 복원이 안됩니다',
  app_uploadPic: '이미지 업로드해주세요',
  app_launchUI: '부팅 인터페이스',
  app_amechine: '대',
  app_chooseCycleType: '반복 방식을 선택해주세요',
  app_formatNotTrueLike: '포멧 오류，예시',
  app_on: '컴퓨터 켜기',
  app_off: '컴퓨터 끄기',
  app_onOff: '컴퓨터 켜기 끄기',
  app_firm: '제조업체 이름',
  // 2017-7-28 wei add
  add_srcFwByName: '이름으로 펌웨어 찾기',
  app_downNum: '다운로드 횟수',
  app_pushed: '기 발표',
  app_notPass: '미통과',
  app_sysType: '시스템 유형',
  app_sys: '시스템',
  app_sysUdPack: '시스템 업데이트 패키지',
  app_chooseFile: '파일 선택',
  app_signCer: '서명인증서',
  app_isUseDisCerAutoSign: '유통업자 인증서로 자동 사인 여부',
  app_useDis: '지정 유통업자',
  app_allDisUsed: '모든 유통업자 통용',
  app_pushInstallTest: '푸시 설정 테스트',
  app_firmware: '펌웨어명',
  app_pushType: '푸시 유형',
  app_dv: '장치',
  // 2017-7-31 wei add
  app_fwType: '펌웨어 유형',
  app_ulNormalSt: '파일을 여기에 끌어오거나 업로드 클릭하기',
  app_selectChannel:'유통업자 선택해주세요',
  app_isSubmitToCheck: '심사 제출 여부',
  app_pleaseInputNo: '단말번호 입력',
  // 2017-8-7 wei add
  app_cnAndActive: '온라인 활성화',
  app_clearCer: '인증서 클리어',
  app_ofCheck: '서명인증 설정 여부',
  app_normal: '정상',
  app_netStatus: '인터넷 상태',
  app_active: '활성',
  app_selfDestroy: '자폭',
  app_mulActive: '대량 활성',
  app_selected: '기선택',
  app_cerCheckOf: '서명 인증 스위치',
  app_openCerCheck: '서명인증 켜기',
  app_closeCerCheck: '서명인증 끄기',
  app_reOpen: '다시 켜기',
  app_reClose: '다시 끄기',
  app_open: '켜기',
  app_usrManage: '유저관리',
  app_stManage: '사양관리',
  app_roleManage: '캐릭터 관리',
  // 2017-8-8 wei add
  app_cerMgType: '인증서 관리 유형',
  app_cerMgSelf: '인증서 자체관리',
  app_cerMgOther: '인증서 대리관리',
  app_cerMgCustomer: '맞춤형',
  app_operateHis: '히스토리 동작',
  app_operateType: '동작 유형',
  app_time: '시간',
  app_isActive: '확성하시겠습니까?',
  // 2017-8-8 wei add
  app_downCer: '인증서 다운로드',
  // 2017-8-10 wei add
  app_isOperate: '조작하시겠습니까?',
  // 2017-8-11 wei add
  app_ulSuccess:'업로드 완료',
  // 2017-7-31 wei add
  app_setting: '설정',
  // 2017-8-15 wei add
  app_clickPicToUlPic: '이미지 위치를 클릭하여 업로드할 이미지를 선택하세요',
  app_within: '이하의',
  app_pgsFormat: 'png、gif、svg포멧',
  app_sgUseAndAdUse: 'svg 포멧 사용을 제안합니다.이미지 색갈은 흰색을 제안합니다',
  app_sureChange: '수정 확인',
  app_logoLvTip: '저장하지 않은 내용이 있습니다.계속 끄겠습니까?',
  app_dfIcon: '기본아이콘',
  // 2017-8-16 wei add
  app_useBigSize: '큰 사이즈 사용',
  app_useBigSizeTip: 'logo가 작아보일 때 이 항목을 선택하여 수정하세요',
  // 2017-8-22 wei add
  app_or: '또는',
  app_format: '포멧',
  app_pic: '이미지',
  app_s: '의',
  app_plsUpl: '업로드하세요',
  // 2017-8-24
  app_upload:'업로드',
  app_cerType:'인증서 유형',
  // 2017-8-31
  app_editProfile: '자료편집',
  // 2017-9-1
  app_cerFile: '인증서 파일',
  app_plsUlPbCer: '고객 인증서를 업로드하십시오',
  app_appNoCerTip: '현재 유통업체는 인증서 자체관리 유통업체입니다.공개키 파일을 업로드하여 서명인증을 하세요',
  app_appNeedCerTip: '현재 유통업테는 인증서가 없습니다.플렛폼 관리자와 연락하여 생성하세요',
  app_createCer: '인증서 생성',
  app_uploadCer: '인증서 업로드',
  // 2017-9-4
  app_fileImport: '파일 들여오기',
  app_mdFile: '양식 파일',
  app_down: '다운로드',
  // 2017-9-5
  app_roleAllot: '캐릭터 분할',
  app_roleName: '캐릭터명',
  app_downTplFile: '양식파일 다운로드',
  // 2017-9-7
  app_verUdCt: '버전 업데이트 내용',
  app_animation: '애니메이션',
  app_per: '매',
  app_minute: '분',
  app_autoRefresh: '자동 리프레시',
  app_level: '등급',
  app_firm: '제조업체',
  app_model: '모델명',
  app_adType: '광고유형',
  app_license: '라이센스코드',
  app_maintain: '유지',
  app_manage: '관리',
  //edit lin
    lin_btn:{
      cancel: "취소",
      add: "추가",
      install:'설치',
      batch_install:'대량 설치',
      tips:'알림',
      confirm:'확인',
      unbind:'언바인딩',
      unbindAll:'대령 바인딩',
      check:'조회',
      reset:'초기화',
      submit:'제출',
      restart:'리셋',
      off:'종료',
      send:'푸시',
      batch_delete:'대량 삭제',
      delete:'삭제',
      lock:'잠금',
      lockOta:'잠금OTA',
      add_zeng:'추가',
      edit:'편집',
      save:'저장',
      bind:'바인딩',
      //20170727새토 추가edit by linziying
      bindAll:'대량 바인딩',
      xiezai:'삭제',
      unlock:'장금 해제',
      change:'수정',

    },
    lin_global:{
      cs_config: '매개 변수 설정',
      task_tips:'설치 완료, 작업 관리자에서 푸시 진도를 확인해주세요',
      task_tips2:'푸시 성공, 작업 관리자에서 푸시 진도를 확인해주세요',
      ope:'동작',
      pselect:'선택해주세요',
      label_no:'장치 번호',
      loading:'데이터 로딩 중',
      label_name:'장치명',
      all_mechanism:'모든 유통업자',
      place_areaid:'유통업자를 선택해주세요',
      time:'시간',
      version:'버전',
      name:'이름',
      remark:'비고',
      edit:'편집',
      label_model:'장치 모델',
      label_type:'장치 유형',
	  device_type_1:"스마트 포스",
	  device_type_2:"기타 설비",
      label_manufid:'장치 제조업체',
      label_areaid:'유통 업자',
      label_areaid_name:'유통 업자명',
      label_address:'장치 주소',
      ter_status:'장치 상태',
	  dest_status:'자폭 상태',
      net_status:'네트워크 연결 상태',
      run_status:'운행 상태',
      online:'온라인',
      offline:'오프라인',
      new_add:'새로 추가',
      normal:'정상',
      marn:'조기 경보',
      fault:'오류',
      success_tips:'동작 완료',
      concel_tips:'최소 완료',
      zlxfs_tips:'명령 전달 성공',
      sb_tips:'동작 실패, 단말 오프라인 상태',
      czsb:'동작 살패',
      zl_error:'명령 전달 오류',
      all_status:'모든 상태',
      delete_success:'삭제 완료',
      look_detail:'상세내용 조회',
      ter_num:'장치 수량',
      ota_bao:'OTA 패키지',
      ple_sel_ota:'OTA 패키지를 선택해주세요',
      unlock_success:'잠금 해제 성공',
      risk_name:'사양명',
      risk_type:'조기경보 유형',
      risk_radius:'펜스 반경(KM)',
      risk_city:'성시를 설정하다.',
      risk_desc:'설명',
      risk_warn_info:'통제 위험 조기경보 정보',
      warn_event:'조기경보 사건',
      city:'도시',
      jwd:'경위도',
      distance:'설정거리 초과(KM)',
      ccwl:'펜스 초과',
      sbyj:'장치 조기경보',
      done:'처리 완료',
      undone:'미처리',
      roles_tips:'캐릭터를 선택해주세요',
      roles_place:'사용자명으로 조회',
      userName:'사용자명',
      nickName:'닉네임',
      phoneNum:'휴대폰',
      roleName:'캐릭터',
      jh:'활성화',
      dj:'봉쇄',
      phoneNum2:'휴대폰 번호',
      resetPass:'비밀번호 초기화',
      revisePass:'수정 비밀번호',
      oldPass:'기존 비밀번호',
      newPass:'새비밀번호',
      comfirmPass:'비밀번호 확인',
      plePassTips:'비밀번호 입력',
      plePassTipsAgain:'비밀번호 재입력',
      pwdDisfault:'비밀번호가 일치하지 않습니다.',
      unfitPhone:'사용할 수 없는 휴대폰번호 입니다',
      nickNameTips:'닉네임 공백불가',
      userNameTips:'아이디 공백불가',
      phoneNumTips:'휴대폰번호 공백불가',
      roleidTips:'캐릭터 공백불가',
      mechanismIdTips:'유통업자 공백불가',
      userStatusTips:'사용자 상태를 설정하세요',
      editPage:'페이지 편집',
      addPage:'페이지 추가',
      status:'상태',
      refs:'데이터를 보완해 주세요',
      user:'계정',
      logStartTime:'로그 시작시간',
      logEndTime:'로그 중지시간',
      download:'다운로드',
      ddsc:'업로드 대기',
      scz:'업로드중',
      scsb:'업로드 실패',
      sccg:'업로드 완료',
      rz_tips:'로그 획득완료，로그관리에서 다운로드 진도를 검색하세요',
      hqrz:'로그획득',
      logoTitle:'TMS 단말 관리 시스템',
      hello:'안녕하세요',
      wdzl:'내 데이터',
      tcxt:'시스템 로그아웃',
      yhdl:'사용자 로그인',
      zh:'계정',
      password:'비밀번호',
      jzmm:'비밀번호 기억하기',
      login:'로그인',
      bah:'심 천시 증권 통 전자 주식 유한 공사, 1993 - 2020 저작권 소유 광 둥 ICP 준비 12035887 호',
      qsrzh:'비밀번호 입력',
      qsrmm:'비밀번호 입력',
      error:'에러',
      wlzt:'네트워크 환경상태',
      ckxq:'상세내용  보기',
      wlmc:'펜스이름',
      wllx:'펜스유형',
      bdsb:'장치 바인딩',
      tjbd:'바인딩 추가',
      bjwl:'펜스 편집',
      wxzyjlx:'조기경보유형 선택',
      cityName:'도시이름',
      sfjxpljb:'선택 바인딩 해제 진행 여부',
      qxzyjbdzd:'바인딩 할 단말 선택',
      jbcg:'바인딩 해제 완료',
      sfjbczd:'해당 단말 바인딩 해제여부',
      sfjxplbd:'선택 바인딩 진행 여부',
      qxzybddzd:'바인딩 할 단말 선택',
      bdcg:'바인딩 완료',
      sfbdczd:'해당 단말 바인딩 여부',
      xzwl:'신규 펜스 만들기',
      qdxysccwl:'해당 펜스 삭제여부 확인',
      tsazcs:'설치테스트 푸시',
      shzt:'심사상태',
      pass: "통과",
      notPass: "불통",
      waitOne: "제출 대기",
      waitTwo: "심사 대기",
      shyy:'심사원인',
      zdtslb:'단말푸시리스트',
      xztghbtg:'통과 혹은 불통 선택',
      qrtj:'제출 확인',
      shcg:"심사 성공",
      syqdsty:'모든 유통업자 일반',
      notBlankName: "명칭 공백 불가",
      notBlankVer:'버전번호 공백 불가',
      qxzlx:'유형 선택',
      qxzscwj:'업로드 파일 선택',
      zdqds:'지정유통업자',
      sfsyzdqm:'유통업자인증서로 자동서명 여부',
      qmzst:'서명인증서',
      azbdz:'Install pack주소',
      qscapkwj:'apk파일을 업로드 하세요, 50M초과하지 않기',
      jwjtdcc:'파일을 여기에 끌어오기, 혹은',
      djsc:'클릭하여 업로드',
      xgscwj:'업로드 파일 수정',
      otaName:'명칭',
      xtlx:'시스템유형',
      syatemR:'시스템ROM',
      sysjota:'시스템업데이트패키지OTA',
      waitOne: "제출 대기",
      waitTwo: "심사 대기",
      verifyPass: '통과',
      verifyNotPass: '불통',
      confirmDelete: "삭제 확인?",
      tjshcg:'심사 제출 완료',
      qdtjsh:'심사 제출 확인',
      allType:'모든 유형',
      smVerify: '심사 제출',
      downNumber:'다운로드 횟수',
      tgmccz:'명칭으로 찾기',
      upload:'업로드',
      xzqddhwj:'부팅 애니메이션파일 선택',
      qxzkjlogo:'시작LOGO선택',
      tpxzds:'이미지 최적화 사이즈 300x300, 부피는 2m 이하 ',
      zmlaun:'개인설정 바탕화면launcher 선택',
      xtjcb:'시스템 기본패키지 선택',
      null:'무',
      shebei:'장비',
      tslxxx:'푸시유형',
      xzbbbbb:'시스템ROM/OTA패키지 선택',
      uploadTime: "업로드시간",
      verTips:'이 버전의 버전된 패키지 기반，버전번호 v 또는 version 문자, 순수 문자，… 과 같다2.2.4',
      verTips1:'버전 번호, 순수 문자 번호, 숫자:2.2.4',
      bbhgsbd:'버전번호 형식 불정확',
      lkymtips:'파일 업로드 중, 현재 페이지를 떠나기 여부확인',
      znscziptips:'zip파일만 업로드 가능',
      qsczipwj:'zip파일 업로드 해주세요',
      //20170727신규 추가edit by linziying
      danweikm:'단위KM',
      weilanshuoming:'설명：장치 마지막 심장박동수의 경위도를 펜스센터로 함',
      pleaseUpload:'업로드 해주세요',
      zdqmTips:'유통업자 자동서명 바인딩여부',
      zhidingqdsxx:'지정 유통업자 정보',
      selectWenjian:'파일 선택',
      qrjxmm:'이 명령을 실행 하시겠습니까: ',
      cicaozuo:'동작?',
      shebeiedit:'장치 편집',
      yxpztitle:'이메일 사양',
      yjyouxiang:'경보 이메일',
      chongzhi:'다시 설정',
      ljchangjian:'지금 만들기',
      ympeizhi:'도메인사양',
      fwqdizhi:'서버주소',
      fwqdztips:'주소에 문자 부호"http://" 불필요, 도메인주소도 가능하고 IP주소도 가능, 예를 들면：www.baidu.com 혹은 127.0.0.1',
      fwqduankou:'서버포트',
      duankoutips:'포트번호에":"추가 불가, 숫사 입력가능 예를 들면：8080',
      tuisongpeizhi:'푸시사양',
      tuisongjl:'푸시기록',
      tuisonglx:'푸시유형',
      chenggong:'성공',
      shibai:"실패",
      tuisongtime:'푸시 시간',
      chongtui:'다시 푸시',
      shebeibei:'장치',
      fwqdzbnwk:'서버주소 공백 불가',
      fwqdkhbnwk:'서버포트번호 공백 불가',
      wdct:'다시 푸시 확인',
      tuisongtips:'아래 도메인사양 푸시여부 확인, 푸시 성공후 다시 시작 활성화',
      //20170731 lin add
      china:'중문',
      english:'영문',

      //20170804 lin add
      cjzs:'인증서 만들기',
      createTime:'만든 시간',
      certificateName:'인증서명',
      xiafa:'전달',
      dachuzhengshu:'인증서도출',
      guojia:'국가',
      shengfen:'성',
      gongsi:'회사',
      youxiang:'이메일',
      youxiaoqi:'유효기간',
      certTypeLabel: '인증서유형',
      certForManufacturer: '제조업체인증서',
      certForCustomer: '고객인증서',
      danweitian:'단위：일',
      xinjian:'새로 만들기',
      notNull:'공백 불가',
      bitian:'필수 입력사항',
      guojiatips:'국가약자，예를 들면 CN',
      shenfentips:'성 영문／병음，예를 들면 GuangDong',
      cityTips:'도시 영문／병음，예를 들면 GuangZhou',
      gongsiTips:'회사 영문／병음，예를 들면 SZZT',
      emailTips:'이메일 주소 입력',
      youxiaoqiTips:'인증서 유효기간 입력, 예를 들면 365',
      xuantian:'선택 입력사항',
      srgsbzq:'입력형식 정확하지 않음',
      cszss:'제조업체인증서',
      khzss:'고개인증서',
      sccszss:'제조업체인증서업로드',
      zhengshu:'인증서',
      qudaoshangxinxi:'유통업자정보',
      quorter:'유통업자 선택 or 장치번호 입력',
      xiafalishi:'전달히스토리',
      resXiafa:'다시전달',
      chongxintuisong:'다시푸시',
      tuisongleixing:'푸시유형',
      dachusiyao:'개인키도출',
      shuaxin:'새로 고침 리스트',
      passWordTips:'비밀번호 공백 불가',
      //20170804 lin add end

      //20170821 lin add
      daochugongyao:'인증서 내보내기',
      //20170821 lin add end


      //20170822 lin add
      zhengshuType:'유통업자인증서유형',
      ziguan:'자체관리',
      daiguan:'대리관리',
      //20170822 lin add end

      //20171128
      app_ispushalldv: '혹시 보내다 모든 장치',


    },
  //edit lin
  terminal: {
    //장치추가

    add:{
      //label값
      //global위치

      //placeholder값
      place_no:"장치번호 입력",
      place_name:'장치명 입력',
      place_model:'장치모델 선택',     //also rules
      place_type:'장치유형 선택',      //also rules
      place_manufid:'제조업체 선택',      //also rules
      //also rules
      place_address:'장치주소 입력',  //also rules
      //popover값
      popover_no:'장치번호는 50자리 이하인 영어, 숫자와 밑줄로 구성!',
      popover_name:'장치명은 50자리 이하인 한자, 영어, 숫자와 밑줄로 구성!',
      //검사규칙
      rules_no_1:'장치번호는 공백 불가',
      rules_no_2:'장치번호 길이는 최대 20자리를 초과해서는 안된다',
      rules_no_3:'장치번호는 영어, 숫자와 밑줄로 구성',
      rules_no_4:'해당 장치번호는 이미 사용중이다！',
      rules_name_1:'장치명은 공백 불가',
      rules_name_2:'장치명 길이는 최대 30자리를 초과해서는 안된다',
      rules_name_3:'장치명은 한자, 영어, 숫자와 밑줄로 구성',
      //제출알람팝업
      success:'추가완료',
      change_success:'수정완료',


    },
    appBind:{
      label_name:'어플명',
      label_version:'버전번호',
      label_size:'어플 크기',
      place_name:'어플명을 입력하여 검색',
      empty_tips:'바인딩 할 어플을 선택!',
      install_tips:'해당 어플 설치 여부 확인?',
      five_tips:'한번에 바인딩 가능한 어플 수량은 최대 다섯개이다',

    },
    appList:{
      label_name:'어플명',
      label_type:'어플유형',
      label_version:'버전번호',
      label_time:'바인딩시간',
      format_status1:'일반어플',
      format_status2:'시스템어플',
      tips1:'해당 어플 제거여부 확인',
      tips2:'바인딩 해제 완료',

    },
    appLog:{
      start_time:'시작시간',
      end_time:'종료시간',
      log_type:'일지유형',
      log_content:'일지내용',


      num:'장치수량',
      tower:'대',

    },
    details:{
      regain:'공장초기화복구',
      run_log:'운행일지',
      risk_info:'리스크정보',
      app_list:'어플리스트',
      app_install:'어플설치',
      send_animate:'푸시애니메이션',
      reset_animate:'복구애니메이션',
      base_info:'기본정보',
      system_info:'시스템정보',
      launcher:'launcher버전',
      system_version:'시스템버전',
	  system_spversion:'보안 칩 버전',
      ota_version:'OTA버전',
      hard_version:'펌웨어버전',
      last_time:'마지막 업데이트시간',
      net_type:'네트워크유형',
      online_time:'온라인시간',
      hard_info:'하드웨어정보',
	  Electric_quantity:"배터리",
	  network:"네트워크",
      cpu:'CPU정보',
      mem:'메모리정보',
      cpuUsed:'CPU사용률',
      memUsed:'메모리 사용률',
      hydh:'애니메이션 복구',
      tips:'애내메이션 복구 유형 선택',
      kjdh:'시작 애니메이션',
      gjdh:'시스템 종료 애니메이션',
      kjlogo:'시작LOGO',
      alldhlogo:'모두(애니메이션과LOGO)',
      zbhy:'일시 복구 안함',
      mshy:'즉시 복구',
      tsdh_title:'푸시 애니메이션',
    animate_name:'애니메이션 이름',
      animatType:'유형',
      position:'플레이 위치',
      createTime:'시간확정',
      animate:'애니메이션',
      kjlogo:'시작LOGO',
      kj:'시작',
      gj:'끄기',
      kgj:'시작하고 끄기',
      comfirm_send:'푸시 애니메이션을 확정하십니까?',
      comfirm_hy:'해당 애니메이션을 복구하시겠습니까?',
      hy_success:'복구완료',
      hy_type:'애니메이션 복구 유형을 선택해 주십시오',
      open_abd:'ADB열기',
      close_abd:'ADB끄기',
      if_ope:'해당 동작을 진행하시겠습니까',

    },
    list:{
      add_btn:'장치 추가',
      import_btn:'장치도입',
      ztgxsj:'상태 업데이트 시간',
      import_title:'장치 정보 들여오기',
      xqwj:'파일선택',
      qrdr:'들여오기 확인',
      import_muban:'들여오기 모듈 다운로드',
      notify_title:'들여오기 결과 알림',
      delete_tips:'이 동작은 해당장치를 영구적으로 삭제합니다. 계속하시겠습니까',
      deletes_tips:'이 동작은 해당장치를 영구적으로 삭제합니다. 계속하시겠습니까?',
      empty_tips:'삭제할 장치를 선택하세요',
      /*20170731추가*/
      excel_tips:'Excel파일만 업로드 가능，10M를 초과해서는 않된다',

    },
    OtaList:{
      lock_num:'잠금한 장치의 수량',
      lock_tips:'이 OTA를 잠금해제 하시겠습니까 ?',

    },
    terRisk:{
      fkpz:'리스크 매니지먼트 사양',
    }
  },
  account:{
    delete_tips:'이 사용자를 삭제',
  },
  // edit mao
  mao_global: {
    btn: {
      sort: "정렬",
      e: "동작",
      cancel: "취소",
      add: "추가",
      edit: "편집",
      submit: "제출",
      update: "수정",
      delete: "삭제",
      ok: "확인",
      selectAll: "전체석택",
      unSelectAll: "전체선택 취소",
      reset: "초기화",
      createNow: "즉시생성",
      confirmUpdate: "수정확인"
    },
    tip: {
      text: "알림",
      confirmDelete: "삭제확인",
      examine: "심사",
      pleaseSelect: "선택",
      pleaseInput: "입력",
      search: "검색",
      notBlank: "공백불가",
      success: "성공",
      fail: "실패",
      notPassExamine: "심사미통과",
      groundsForRefusal: "거절 이유 입력",
      notReset: "삭제후 복구불가"
    }
  },
  /*메뉴*/
  menu: {
    home: "처음 페이지",
    terManage: "장치관리",
    terManageSub: {
      myTer: "내 장치",
      breakup: "단말 백업",
      lockOTA: "단말잠금",
      map: "단말지도",
      log: "로그관리",
      addTer:"단말추가",
      detailTer:"단말 디테일",
      riskInfo:"리스크 매니지먼트 정보",
      runLog:'동작 로그',
      appList:'애플리케이션 리스트',
      appInstall:'애플리케이션 설치',
      otaLock:'OTA잠금',

    },
    advertManage: "광고관리",
    advertManageSub: {
      list: "광고리스트",
      examine: "광고심사",
      examineDetail: "심사 디테일",
      edit: "광고편집",
      detail: "광고 디테일",
      vlist: "동영상 광고를 목록",
      vverify: "동영상 광고를 심사",
      addVideo: "비디오 광고 추가",
      dfVList: "기본 비디오 목록",
      addDfVideo: "기본 동영상 추가"
    },
    appManage: "애플리케이션 관리",
    appManageSub: {
      list: "애플리케이션 리스트",
      market: "앱스토어",
      custom: "내 옵션에 추가",
      viewApp: "애플리케이션 찾아보기",
      customPush: "옵션푸시",
      appPush: "애플리케이션 푸시",
      appBind: "애플리케이션과 단말 바인드",
      examine: "애플리케이션 심사",
      verifyApp: "애플리케이션 심사",
      appEdit: '애플리케이션 편집',
      appDetail: '애플리케이션 디테일',
      uploadNew: '새로운 버전 업로드',
      uploadApp: '애플리케이션 업로드'
    },
    taskManage: "태스크 관리",
    taskManageSub: {
      list: "태스크 관리",
      detail: "태스크 디테일",
      listHis: "완료된 작업",
      detailHis: "완료된 작업 정보"
    },
    dataManage: "데이터 관리",
    dataManageSub: {
      channel: "유통업자 관리",
      factory: "제조업체 관리",
      terClassify: "장치유형 관리",
      terNum: "장치모델 관리",
      advertClassify: "광고유형 관리",
      appClassify: "애플리케이션 유형 관리",
      newChannel: "유통업자 추가",
      editChannel: "유통업자 편집",
      newFirm: "제조업체 추가",
      editFirm: "제조업체 편집"
    },
    railManage: "리스크 매니지먼트 관리",
    railManageSub: {
      penSetting: "펜스 설정",
      warnSetting: "예고 메시지",
      riskDetail:"펜스 디테일",
    },
    //lin add 20170804
    safeManage: "안전관리",
    safeManageSub:{
      certificate:"증서 관리",
      certNew:"증서 생성",
      remote:"원격수권",
      certUpload:"제조업체 증서 업로드",
      certDetail:"증서 디테일",
      cerUpload:"증서 업로드",
      myCert:'내 증서'
    },
    //lin add 20170804 end
    sysManage: "시스템 관리",
    sysManageSub: {
      romul: 'OTA 업로드',
      romed: 'OTA 편집',
      romOTA: "OTA관리",
      examine: "OTA심사",
      push: "OTA푸시",
      order: "시스템 맞춤제작",
      animation: "애니메이션 맞춤제작",
      animateCustom: "애니메이션 맞춤제작",
      animatePush: "애니메이션 푸시",
      pushHistory: "푸시 히스토리",
      firmwareManage: '펌웨어 관리',
      firmwareUpload: '펌웨어 업로드',
      firmwareEdit: '펌웨어 편집',
      firmwareCheck: '펌웨어 심사',
      firmwareCheckDt: '펌웨어 디테일',
      firmwarePush: '펌웨어 쿠시',
      firmwarePushDevice: '펌웨어 보내다 장치',
      launchManage: 'launcher 관리',
      launchCheck: 'launcher 심사',
      verifyLaunch: '심사 launcher',
      addLaunch: '추가 launcher',
      launchDetail: 'launcher 정보',
      launchEdit: 'launcher 편집',
      launchNewVer: 'launcher 업로드 신판',
      launchPush: 'Launcher 보내다',
      launchPushTer: 'Launcher 보내다 터미널'
    },
    setManage: "사양관리",
    setManageSub: {
      role: "캐릭터 관리",
      system: "시스템 사양",
      menu: "메뉴리스트",
      addRole: "캐릭터 추가",
      rightChange: "권한 수정",
      logo: 'LOGO설정'
    },
    accManager: "계정관리",
    accManagerSub: {
      account: "계정정보",
      subAccount: "서브계정 정보",
      addAccount:'서브계정 추가',
      editAccount:'서브계정 편집',
    },
    menuEdit: '메뉴 편집'
  },
  /*메뉴 END*/
  /*광고*/
  advert: {
    status: "광고상태",
    addAdvert: "광고 추가",
    deleteAll: "대량삭제",
    all: "전체",
    refusal: "이유설명",
    app: "애플리케이션",
    appSub: {
      name: "이름",
      classify: "유형",
      uploadTime: "업로드시간",
      version: "버전번호"
    },
    isPass: "통과 여부",
    pass: "통과",
    notPass: "미통과",
    waitOne: "심사제출 대기",
    waitTwo: "심사대기",
    addDate: "시간추가",
    addUser: "추가인",
    appName: "애플리케이션 이름",
    img: "이미지",
    name: "광고이름",
    classify : "광고유형",
    position : "광고위치",
    positionSub: {
      banner: "첫 페이지Banner",
      starPage: "시작 페이지"
    },
    jumpType: "점프 타입",
    jumpTypeSub: {
      net: "웹페이지",
      appStore: "앱스토어"
    },
    url: "URL",
    channel: "유통업자",
    ableDate: "유효기간",
    beginDate: "시작시간",
    endDate: "종료시간",
    contentImg: "광고내용",
    reset: "초기화"
  },
  /*광고 END*/
  /*첫페이지*/
  index: {
    t: "대",
    more: "더보기",
    terStatus: "장치 개황",
    onlineTer: "온라인 장치",
    offLineTer: "오프라인 장치",
    warnTer: "경보장치",
    taskList: "태스크 리스트",
    pullApp: "애플리케이션 전달",
    romUpdate: "ROM업데이트",
    pullAdvert: "광고 푸시",
    infoList: "정보 리스트",
    riskWarn: "리스크 매니지먼트 경고",
    breakWarn: "고장경고"
  },
  /*첫 페이지 END */
  taskTypeNames: {
    ALL: "모든 종류",
    APP: "응용",
    OTA: "OTA",
    ROM: "ROM",
    FIRMWARE: "펌웨어",
    AD: "광고",
    STARTUP_ANIMATION: "기계를 애니메이션",
    SHUTDOWN_ANIMATION: "컴퓨터 끄기 애니메이션",
    STARTUP_SHUTDOWN_ANIMATION: "스위치 기계 애니메이션",
    LOGO: "LOGO",
    LAUNCHER: "Launcher",
    WALLPAPER: '바탕 화면'
  },
  /*사양관리*/
  menuConfig: {
    menu: {
      addMenu: "페런트 메뉴추가",
      refreshMenu: "새로 고침 메뉴",
      addMenu2: "메뉴추가",
      menuName: "메뉴이름",
      selectModel: "모듈선택",
      orderBy: "순번배열",
      notBlankName: "이름 공백불가",
      editMenu: "메뉴편집",
      editSuccess: "편집완료",
      addSubMenu: "서브메뉴추가",
      relUrl: "상대주소"
    },
    // 사양관리 - 캐릭터관리
    role: {
      addRole: "캐릭터 추가",
      no: "번호",
      name: "이름",
      mark: "묘사",
      model: "모듈",
      updatePermission: "권한수정",
      editRole: "캐릭터 편집",
      notBlankName: "이름 공백불가",
      updateSuccess: "업데이트 완료",
      deleteSuccess: "삭제 환료",
      modelSelect: "모듈 선택",
      addSuccess: "추가 완료"
    }
  },
  /*사양관리 end*/

  app_adname: '광고 이름',
  app_allpush: '보내다, 다',
  app_fipush: '가져올 파일 보내다',
  app_isjtoviewtd: '혹시 위치로 이동 작업 정보 보기 보내다 진행',
  app_mgsys: '시스템 도메인 이름',
  app_edcode: '관리 인증 코드',
  app_sapp: '응용 프로그램 선택',
  app_spic: '그림을 선택하십시오.',
  app_iappnamesrch: '응용 프로그램 이름을 입력하십시오. 조회',
  app_alltyps: '모든 종류',
  app_allpp: '모든 재생 위치',
  app_addur: '광고 때 길다',
  app_vsize: '비디오 크기',
  app_addtime: '시간 추가',
  app_psverify: '통해 심사',
  app_vpreview:'비디오 미리 보기',
  app_cstandt: '선택할 때 긴 와 횟수',
  app_additv: '추가 때 길다',
  app_vdofile: '비디오 파일',
  app_filename: '파일 이름',
  app_vdodur: '비디오 때 길다',
  app_clreulvdo: '다시 동영상 올린 클릭',
  app_adddfvdeoad: '기본 비디오 광고 추가',
  app_addps: '추가 인원',
  app_pltimes: '재생 횟수',
  app_pldur: '재생 때 길다',
  app_csvldate: '선택 유효기간',
  app_advdoad: '비디오 광고 추가',
  app_mgdfvdo: '관리 기본 비디오',
  app_adstatus: '광고 상태',
  app_addadtype: '새로운 광고 형식',
  app_newapptype: '새로운 응용 형식',
  app_addmodel: '신규 모델',
  app_newdvtype: '추가 장치 종류',
  app_addfmname: '새로운 메이커 이름',
  app_srpush: '확인 보내다',
  app_ulfile: '업로드',
  app_ttpsddvnum: '이번 보내다 완료 장치 갯수',
  app_srsktsdv: '너 정말 이 장치에 건너뛰기',
  app_cvpush: '덮어쓰기 보내다',
  app_skpush: '건너뛰기 보내다',
  app_pssuccess: '보내다 성공',
  app_nowjump: '곧 갑니다',
  app_bcrecov: '대량 복원',
  app_skintro: '간결한',
  app_addlc: 'launcher 추가',
  app_ulinsfile: '파일 업로드 설치',
  app_clreul: '클릭 다시 업로드',
  app_lcname: 'launcher 이름',
  app_rsfivemin: '매 5분 자동 새로 고침',
  app_suresm: '확인 제출',
  app_udfiletype: '업데이트 파일 형식',
  app_plsltype: '형식을 선택하십시오.',
  app_adnamenotnull: '광고 이름 못 비어',
  app_plslchannel: '채널 상업 선택하십시오.',
  app_plslplpos: '재생 위치를 선택하십시오.',
  app_slsttime: '시작 시간 선택하십시오.',
  app_slendtime: '끝나는 시간 선택하십시오.',
  app_addsc: '추가 성공',
  app_vlsuccess: '심사 성공',
  app_opsuccess: '작업이 성공적으로',
  app_srpassvf: '확인 통해 심사',
  app_addvdoad: '비디오 광고 추가',
  app_edvdoad: '편집 동영상 광고를',
  app_sllimit: '선택 유효기간',
  app_srmuldel: '대량 삭제 확인',
  app_sttcanlateendtime: '시작 시간 못 늦다 종료 시간',
  app_etcanelsttime: '종료 시간 이전일 수 없습니다 시작 시간',
  app_srdelpush: '삭제 확인 보내다',
  app_srrecovsysdf: '확인 시스템 기본값으로 되돌립니다',
  app_rdless: '펜스 반경 작음',
  app_srban: '확인 안 통해',
  app_banandrs: '혹시 안 통해 입력하십시오. 안 통해서 원인을?',
  app_trjmap: '추적 지도',
  app_psdonelftip: '이번 보내다 있다 {num} 설비는 이미 완성 보내다 또는 지금 보내다, 당신 이 장치를 했었지?',
  app_tipdown: '힌트 다운로드',
  app_psscandtip: '힌트 설치 성공 보내다',
  app_csulpicbsis: '클릭 선택 올린 사진 보기 위해, 베스트 사이즈',
  app_srch: '검색',
  app_lkdevice: '장치를',
  app_app: '응용',
  app_firmw: '펌웨어',
  app_refresh: '새로 고침',
  app_sleep: '휴면',
  app_ccdown: '취소 다운로드',
  app_iscancelPush: '혹시 취소 보내다?',
  app_fmVerIillegal: '버전 번호 안 합법적인 반드시 숫자를 1.0.0 같다.',
  app_verror: '버전 이상',
  app_other: '기타',
  app_inssuccess: '설치 성공',
  app_tipterop: '힌트 단말 작업',
  app_autocmpl: '자동 완성',
  app_noresetfs: '기기가 현재 공장 출하 상태입니다. 관리자에게 문의하여 초기화하십시오.',
  app_saleSt: '출하 상태',
  app_actst: '활성 상태',
  app_insfail: '설치 실패',
  app_checksignfail: '검사하다, 싸인 실패',
  app_asc: '오름차순',
  app_desc: '내림차순',
  app_utasc: '업데이트 시간 오름차순',
  app_utdesc: '업데이트 시간 내림차순',
  app_srchcontent: '검색 내용',
  app_account: '계좌 번호',
  app_opecontent: '조작 내용',
  app_opetime: '작업 시간',
  app_frzaccount: '얼음이 아이디',
  app_operator: '조작 사람',
  app_userip: '사용자 IP',
  app_deskwp: '바탕 화면',
  app_channelmcdetail: '채널 상세',
  app_channellevel: '등급 상등',
  app_cermanage: '인증서 관리',
  app_lineimportcer: '산선 가져오기 증서 가져오기',
  app_devicemanage: '장치 관리',
  app_fileimportdevice: '파일 가져오기',
  app_lineimportdevice: '산선 가져오기',
  app_prodmodel: '제품 모델',

  app_plimportcer: '클라이언트 인증서 가져오기',
  app_importslorder: '선택한 주문서를 가져오기',
  app_importslcustomer: '선택한 클라이언트 가져오기',
  app_customername: '클라이언트 이름',
  app_orderno: '주문 번호',
  app_orderfinishdate: '주문 완료 날짜 완성 날짜',
  app_customerno: '고객 인코딩',

  app_debuginfo: '디버그 정보',
  app_adbstatus: 'ADB 상태',
  app_on1: '열다',
  app_off1: '닫다',
  app_devicemode: '장치 모드',
  app_normalmode: '정상 모드',
  app_debugmode: '디버깅 모드',
  app_signstatus: '검사 상태.',
  app_catchlog: '클러치 로그',
  app_tobenimportdv: '가져올 장치',
  app_lineimporttip: '설비의 유형, 공장, 모델, 주소 등 기본 데이터를 설정하십시오',
  app_cannotwithsysapp: '시스템 애플리케이션을 포함할 수 없습니다.',
  app_locktime: '잠금 시간',

  app_risksetting: '바람 설정',
  app_lockinfo: '정보 잠금',

  app_riskdetail: '예고한 상세한 상황.',
  app_lockcity: '도시 를 정하 다',
  app_locklngandlat: '위도를 고정시키다.',
  app_lockstate: '잠금 상황 묘사',
  app_bindenclosure: '둘러싸다',
  app_unbindenclosure: '울타리를 묶다.',
  app_sureunlock: '잠금 해제',
  app_plsinputimgfile: 'IMG 형식 파일 올려주세요.',

  app_animatefile: '애니메이션 파일',

  app_bglock: '빽 잠그기',
  app_request: '신청하다',
  app_unrequest: '미청',

  app_lockdevice: '설비를 정정하다.',
  app_pusheddvlist: '앱 제거',
  app_appuninstall: '마운트 적용하기',

  app_unlocked: '잠금 해제',
  app_unlockdevice: '잠금 해제 장치',

  app_pushnumcantfive: '밀송 수량이 5 개를 넘으면 안 돼요.',
  app_selectedappshoupass: '선택한 응용 프로그램',
  app_misstokentip: '로그인 정보 분실, 재등록권 필요',

  app_adRefreshfreq: '광고 쇄신 주파수',

  app_uninsfail: '마운트 해제 실패',
  app_uninssc: '마운트 해제 성공',
  app_preversion: '기초 버전',
  app_rdneedmore: '포위 난간 은 반경 이 크게 필요할 것 이다',

  app_addstfile: '설정 파일 추가',
  app_filetag: '파일 형식',

  app_filestss: '설명',
  app_uploadfilest: '설정 파일 업로드',
  app_excludeapp: '적용 배제',
  app_reupload: '다시 올린다',
  app_excludefsttip: '배제할 애플리케이션 추가, 온전한 애플리케이션 이름을 입력하면 이 프로그램을 제거합니다. 기본 지원하는 이 파일 표기의 적용을 기본값으로 사용하려면 이 설정을 사용할 수 있습니다',

  app_limitxml: '제한 xml 파일',
  app_configfile: '파일 설정',

  app_udversion: '업데이트 버전',

  app_udsamexml: '같은 표시 xml 로 갱신할 수 있습니다.',
  app_udxmllowertip: '업데이트 버전이 현 버전보다 낮은 것으로 기록되어 있습니다. 목록에 표시되지 않습니다.',

  app_childacmg: '부좌 번호 관리',

  app_unldvwftip: '이 설비는 포위 표시줄 [{wl}], 바인드를 동시에 삭제하시겠습니까?',

  app_udmode: '업데이트 모드',
  app_append: '추가하다.',

  /*** 非智能设备管理 */
  app_importapp: '가져오는 응용 프로그램 가져오기',
  app_adddate: '날짜 추가',
  app_addtask: '작업 추가',
  app_addtesttask: '작업 추가',
  app_appdesc: '설명',
  app_srcdesc: '자원 묘사',
  app_downapp: '다운로드 응용',
  app_downfile: '파일 다운로드',
  app_addsrc: '자원 추가',
  app_importsrc: '리소스 가져오기',
  app_srcname: '자원 이름',
  app_srcver: '자원 버전',
  app_downsrc: '자원을 다운로드하다',
  app_number: '편성 번호',
  app_softinfo: '소프트웨어 정보',
  app_allstatus: '모든 상태',
  app_mstype14: '스모크 총',
  app_mstype15: '총자원의 문건을 쓸어 보내다.',
  /*** end */

  app_filedesc: '파일 설명',
  app_filetype: '파일 형식',
  app_subtype: '동자 유형',
  app_addfile: '파일 추가',
  app_stmgpsw: '비밀번호 관리 설정',
  app_mapsl: '지도 선택',
  app_bdmap: '백도',
  app_map: '지도.',
  app_right: '권한',
  app_addconfig: '설정 추가',
  app_editconfig: '설정 편집',
  app_mgpsw: '비밀번호 관리',
  app_dvconfiglist: '설정 장치 목록',
  app_appconfigst: '응용 프로그램 설정',
  app_applytime: '응용시간',
  app_secrname: '키 이름',
  app_secrdesc: '키 설명',
  app_addsecrrule: '키 규칙 추가',
  app_editsecrrule: '키 규칙 편집',
  app_secrdvlist: '키 장치',
  app_secrupdatest: '키 업데이트 상태',
  app_waitupdate: '업데이트',

  app_addrandport: '주소 및 포트',
  app_filepath: '파일 경로',
  app_queryudfre: '업데이트 업데이트',
  app_lcupload: '로컬 업로드',
  app_hour: '시간',
  app_addofcloud: '구름 추가',
  app_bglist: '배경 목록',
  app_cntype: '연결 방식',
  app_codegunsrc: '총자원을 청소하다.',
	app_rtosgunsrc: 'RTOS 자원',
	
	app_rots_1:"app를 적용하다",
	app_rots_2:"자원 source",
	app_rots_3:"시스템 sys",
	app_rots_4:"보안 칩 펌웨어 버전 sp",
	app_rots_5:"마스터 버전 mt",

  app_partpkg: '증량 가방',
  app_codegunapp: '소탕총 응용',
  app_starttime: '시작 시간',

  app_oilmcsrc: '주유기 자원',

  app_downtpl: '템플릿 다운로드',

  app_plsstype: '자형 종류 선택',

  app_allstyps: '모든 자형 종류',

  app_ftooltip: '애니메이션 / 로고파일 온라인 제작 도구',

  app_appendpush: '추가 밀송',

  app_ipitonlylgchar: '입력 항목은 영문 숫자와 밑줄 등 합법적인 문자가 될 수 있다',

  app_enable: '활성화',

  app_spfileis: '파일 지원 형식',

  app_cnsetting: '연결 설정',

  app_newtask: '새 작업',
  app_adddv: '설비를 추가하다',
  app_fileinsst: '파일 설치 설정',
  app_insscautoop: '설치 성공 자동 열기',
  app_pushsctipins: '밀송 성공 힌트 설치',
  app_total: '총수',
  app_wait: '기다리다',
  app_pushing: '밀송하고 있어요.',
  app_pushsldev: '선택한 장치',

  app_repushdv: '실패 설비를 다시 미루다.',
  app_outputdv: '내보내기',

  app_udtime: '업데이트 시간',
  app_surepsxdv: '장비 {num} 대를 확인하여 설비를 송달하다.',

  app_apppush: '응용',
  app_fmwpush: '고지',
  app_advpush: '광고',
  app_onampush: '개기 애니메이션 밀송',
  app_offampush: '컴퓨터 끄기 애니메이션 밀송',
  app_onoffampush: '스위치 엔진',
  app_onlgpush: '개기 로고',
  app_wppush: '벽지',
  app_stfpush: '파일 배송 설정',
  app_codemc: '코드기',
  app_codemcsrc: '소압기 자원',
  app_sysud: '시스템 업데이트',
  app_fmwud: '고지 업데이트',
  app_anmud: '애니메이션 업데이트',
  app_qcgunsrcps: '총자원을 쓸어 보내다.',
  app_iscltask: '임무를 취소할 것을 확정 하다',
  app_resrc: '자원',
  app_srcfileps: '자원 파일 밀송',
  app_fmVerIillegal1: '버전 번호 의 비합법적 으로, 반드시 v 와 숫자 가 반드시 v 1.0.0 이다',

  app_helptip: '일깨워 주다',
  app_newpsetnewver: '새로운 버전 TMS 의 밀송 기능 개편',
  app_newptdetail: '	기능 개편 후, 사용자는 밀송 미션 페이지를 열 수 있습니다 (미션 관리 → 밀송 미션), 새 작업, 새로운 작업 페이지에 진입하며, 미션의 이름을 입력하고, 필요한 파일을 입력하십시오.',
  app_newptdetail1: '	작업 새 작업 완료된 후 자동 이동에 대한 자세한 정보 파출 장치 선택, 사용자가 대량 추출 또는 단대 설비에서 사용할 수 있습니다. 미션의 자세한 설비를 여러 번 추가 설비를 추가할 수 있습니다. 많은 양의 밀송 전에 소량의 설비를 먼저 미팅하고, 확인되지 않은 후 미션에서 클릭하면 설비를 추가할 수 있습니다.보내다',

  app_daterange: '날짜 범위',
  app_olinepday: '하루 온라인',
  app_onlineavgt: '평균 시단',
  app_devicewhe: '장치 분포',
  app_statistic: '통계.',
  app_today: '오늘',
  app_thisweek: '금주',
  app_thismonth: '금월',

  app_addblfile: '블랙리스트 파일 추가',
  app_blacklsname: '블랙리스트 이름',
  app_editblls: '블랙리스트를 편집하다.',
  app_blsdesc: '블랙리스트 묘사',
  app_blsdvlist: '블랙리스트 장치 목록',

  app_wldesc: '포위 묘사',
  app_filectncr: '파일 내용이 정확하지 않다.',

  app_khour: '때',
  app_kday: '날',
  app_yesterday: '어제',
  app_rc15d: '최근 15 일',
  app_rc30d: '최근 30 일',
  app_stinfo: '상태 정보',

  app_croln: '현재 온라인',
  app_crslp: '현재 휴면',
  app_croff: '현재 이선',
  app_lstol: '마지막 온라인 타임',
  app_lstsl: '마지막 휴면 시간',
  app_lstof: '마지막 오프라인 시간',
  app_limitiplg: 'IP 로그인 제한',
  app_illegal: '불합법',
  app_limitiptip: '필요한 규제를 입력하십시오. 입력하지 않으면 제한되지 않습니다.',
  app_unknow: '알 수 없다.',
  app_hisstatus: '역사 상태.',
  app_allowiplg: 'IP 로그인 허용하기',
  app_allowiptip: '허용된 IP 단을 입력하십시오. 입력하지 않으면 모든 IP 방문을 허용합니다',
  app_active1: '활발하다',
  app_unuse: '비활성화됨',
  app_addpsg: '채널 추가',
  app_psgname: '채널 이름',
  app_authstat: '인증 상태',
  app_cbackad: '전조 주소',
  app_bsrqsadwl: '업무 요청 주소 백명부',
  app_appwtls: '명단을 적용하다.',
  app_addapppgkn: '가방 추가',
  app_authopen: '권한을 부여하다.',
  app_authclose: '권한을 부여하여 닫히다.',
  app_addaddr: '주소 추가',
  app_developer: '개발자',
  app_editpasg: '채널',
  app_usertype: '사용자 종류',
  app_generate: '생성',
  app_gentip: 'APSe시크릿을 재생성 후 기존 APSe시크릿은 효력을 잃었고, 오픈 플랫폼을 이어갈 수 없습니다.APSe시크릿을 다시 생성할 수 있는지 확인하시겠습니까?',
  app_open1: '열다.',
  app_hide: '숨다',
  app_subtask: '자제 임무',
  app_sltstype: '작업 형식 선택',
  app_command: '명령',
  app_addsubts: '추가 작업',
  app_commtype: '명령어 형식',
  app_taskpros: '작업 진행',
  app_cursubts: '현재 부스',
  app_commpush: '명령어',
  app_dvrestart: '장치 재개',
  app_recvorgst: '공장 출하',
  app_recvanimt: '애니메이션',
  app_dvlock: '장치 장치',
  app_dvunlock: '장치 잠금',
  app_inbdside: '이제 변경입니다.',
  app_subtsnum: '자 미션수',
  app_tscrtime: '작업 생성 시간',
  app_ing: '진행 중',
  app_core: '내핵',
  app_filesys: '파일 시스템',
  app_commd1fw: '통신 모듈 1',
  app_commd2fw: '통신 모듈 2',
  app_readcfw: '카드 읽기',
  app_pswkbfw: '암호 키보드',
  app_scanhfw: '스캐너',
  app_actpossp: '활성화 POS 통화 활성화',
  app_natpossp: 'POS 통화 닫기',
  app_setcallf: '통화 기능 설정',
  app_clupappdt: '데이터를 지우기',
  app_isclupappdt: '응용 프로그램 지우기',
  app_impdistbt: '가져오기',
  app_impmctip: '이 파일 업로드 중 10 m 이상 지원할 수 없습니다.',
  app_callfunc: '통화 기능',

  app_protocal: '프로토콜',
  app_prtsltip: 'HTTPS 를 선택할 때, 이 프로토콜을 지원해야 할 인터페이스를 반드시 지원해야 합니다',
  app_rgsvpm: '인증 서비스 변수',
  app_rgsvip: 'IP IP IP IP',
  app_bgntpm: '배후 알림 변수',
  app_bgntip: '배경 정보 IP IP',
  app_port: '포트',
  app_flexist: '파일이 이미 존재합니다.',
  app_cerid: '인증서 지문',
  app_wallpaper: '벽지',

  app_forceins: '강제 설치',
  app_autorun: '자동 운행',
  app_cusins: '객화 설치',
  app_cusuins: '객화 해재',
  app_forcerun: '강제 집행',
  app_pushtest: '테스트 (하다)',
  app_pltfblt: '플랫폼 공고',

  app_addblt: '공고 추가',
  app_blttt: '공지 제목',
  app_readnum: '읽은 횟수',
  app_bltct: '공고 내용',
  app_pltudrd: '플랫폼 업데이트',
  app_udlog: '로그 업데이트',
  app_addver: '버전 추가',
  app_pubdate: '기일을 발포하다.',
  app_updct: '업데이트 내용',
  app_editblt: '공고 편집',
  app_editver: '버전 편집',
  app_verupdate: '버전 업데이트',
  app_clviewdt: '보기 자세한 정보 클릭',
  app_viewmore: '보기',
  app_comptime: '번역 시간',
  app_insafnorun: '설치 후 비자동 실행',
  app_normalins: '일반 설치',
  app_normalunins: '기본 마운트',
  appp_tipoperate: '힌트',
  app_onlyprov: '선택성',
  app_filepush: '파일 송송',
  app_region: '구역',
  app_srcmechan: '키워드 검색 루트 입력',
  app_ckcode: '검증 코드',
  app_cantuins: '해제할 수 없음',
  app_ippkgname: '패키지 이름 입력',
  app_onlypicfm: '사진 형식 파일만 올릴 수 있습니다 (JPG, PNG, GIF...)',
  app_fludlist: '파일 업데이트 목록',
  app_param: '인자',
  app_catching: '잡은 중',
  app_ulding: '업로드 중',
  app_ulyet: '업로드 완료',
  app_endcatch: '캡처 끝',
  app_iscatch: '검색 시작？',
  app_opterinfo: '터미널 정보 내보내기',
  app_bcopterinfo: '도량 터미널 내보내기',
  app_cpttime: '절취 시간',
  app_eqcapture: '장치 캡처',
  app_scapture: '캡처',
  app_surestcap: '캡처 확정？',
  app_lokscrn:'자물쇠 스크린',
  app_ulkscrn:'화면 제거',
  app_appautrn:'App 자체 시작',
  app_perms: '단위:밀리초',
  app_wattime: '시간을 기다리다',
  app_lcswitch: 'launcher 전환',
  app_appadv: '응용 광고',
  app_cardno: '카드번호',
  app_trdno: '일련 번호',
  app_batcno: '번호 매기 기',
  app_amout: '금액',
  app_mechno: '상호',
  app_trdtime: '거래 시간',
  app_trddate: '거래 날짜',
  app_trdcore: '핵심 흐름',
  app_expno: '참고 번호',
  app_trdtype: '거래 유형',
  app_rectime: '시간 을 기록 해',
  app_fpaddrs: '얼굴 사진 주소',
  app_propcut: '비례 에 따라 재단 하 다',
  app_getcash: '현금 인출',
  app_lctrans: '줄 내 계좌 이체',
  app_obtrans: '다른 은행 으로 이체 해 주세요',
  app_coretrans: '핵심 흐름',
  app_tradeNo: '거래 번호',
  app_export: '내 보 내기',
  app_ctrc: '마 그 네 틱 카드 리더',
  app_icrc: 'IC 카드 리더',
  app_prtst: '프린터 상태',
  app_pswkb: ' 비밀번호 키보드',
  app_idfrc: '주민등록증 리더',
  app_led: 'LED',
  app_beep: '버저',
  app_codebar: '바코드',
  app_lulog: '로그 보기',
  app_lust: '상태 보기',
  app_mdclst: '모듈 호출 통계',
  app_fcclst: '방법 호출 통계',

  app_acauth: '쿠폰 인증',
  app_authcode: '활성 코드',
  app_authrange: '프로그램 유효기간',
  app_delact: '잠시 활성화 하지 않 음',
  app_pswtip: '비밀 번 호 는 대문자, 소문 자, 숫자 와 특수 부 호 를 포함 하여 8 자리 이상 이 어야 한다.',
  app_phontrs: '핸드폰 번호 이체',
  app_mulfcau: '多因子认证',
  app_verifc: '验证',
  app_opmfackip6dycode: '请打开MFA验证器，输入6位动态验证码',
  app_cantprvmcodectadm: '如不能提供多因子认证验证码，请与管理员联系',
  app_lsstep: '上一步',
  app_nxstep: '下一步',
  app_ckidt: '验证身份',
  app_istapp: '安装应用',
  app_bindmfa: '绑定MFA',
  app_ipaclgpsw: '输入账号登录密码',
  app_bindsfdv: '  绑定安全设备',
  app_psfwtsstepop: '请按以下步骤完成绑定操作',
  app_sixnumb: '6位数字',
  app_phdnalyappggidck: '请在手机端下载并安装阿里云APP/Google Authenticator（身份验证器）',
  app_ipappstsagidck: 'iphone：在AppStore搜索阿里云APP/Google Authenticator（身份验证器）',
  app_adappmksagidck: 'Android：在应用市场搜索阿里云APP/Google Authenticator（身份验证器）',
  app_afistclnxitbpagiinx: '安装完成后点击下一步进入绑定页面（如已安装，直接进入下一步）',
  app_usalyagidckscqrc6code: '使用阿里云APP/Google Authenticator（身份验证器）扫描以下二维码，获取6位验证码',
  app_sftkck: '安全令牌验证',
  app_ip6codeubac: '输入6位验证码解除绑定账户',
  app_plipopenalyappoggidckip6dycd: '请在手机中打开阿里云APP或Google Authenticator（身份验证器）,请输入6位动态码',
  app_select_timelist:"시간 범위 선택",
  app_batch_migration:"일괄 마이그레이션",
  app_sure_migration:"이전 확인",
  
}

export default korean;



// WEBPACK FOOTER //
// ./src/components/language/ko.js